import { Injectable } from '@angular/core';
import { OtpApiService } from '@domain/infrastructure/api/otp/otp-api.service';
import { OtpMailRequest } from '@utils/classes/request/otp-mail-request';
import { OtpValidationRequest } from '@utils/classes/request/otp-validation-request';
import { IOtpController } from '@utils/interfaces/controller/otp-controller.interface';
import { IOtpMailResponse } from '@utils/interfaces/response';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OtpFacade implements IOtpController {

  constructor(private readonly api: OtpApiService) { }

  otpMail(otpMailRequest: OtpMailRequest): Observable<IOtpMailResponse> {
    return this.api.otpMail(otpMailRequest);
  }
  otpValidation(otpValidationRequest: OtpValidationRequest): Observable<void> {
    return this.api.otpValidation(otpValidationRequest);
  }
}